<script>
// definir un objeto mixin
export default {
  data() {
    return {
      loading: false,
    };
  },
  created: function () {},
  computed: {},
  mounted() {},
  methods: {
    parseErrorResultValidation(result) {
      if (!result.status) {
        // Si result.result es null o no tiene campos, devolver el mensaje directo
        if (!result.result || Object.keys(result.result).length === 0) {
          return result.msg || "Error desconocido";
        }

        var mensaje = "";
        for (const field in result.result) {
          if (Object.prototype.hasOwnProperty.call(result.result, field)) {
            // Mostrar el campo y los errores de validación asociados
            mensaje += `Errores de validación para el campo "${field}":\n`;
            /*
            const validationErrors = result[field];
            validationErrors.forEach((error) => {
              console.log(`- ${error}`);
            });
            */
          }
        }

        return mensaje;
      } else {
        return result.msg;
      }
    },
  },
};
</script>
